var exports = {
  "Ws": "sponsorIcon__j5Jc88",
  "J7": "platformIconCircle__jTagou",
  "qc": "platformIconImage__8gnN5F",
};

module.exports = exports;
